import { useEffect, useState } from "react";

const useWindowSize = () => {
  let [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const resize = () => {
      setWindowWidth(window.innerWidth)
    };
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);
  return windowWidth;
};

export default useWindowSize;
